export default function FeatureComparison() {
  const features = [
    { name: 'Aktualizacje', usfans: true, excel: false, sheets: true },
    { name: 'Prostota', usfans: true, excel: false, sheets: true },
    { name: 'Bezpieczeństwo', usfans: true, excel: true, sheets: true },
    { name: 'Organizacja', usfans: true, excel: false, sheets: true },
    { name: 'Współpraca', usfans: true, excel: true, sheets: true },
    { name: 'Dostęp offline', usfans: true, excel: true, sheets: false },
  ];

  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-6 md:gap-8 mb-12">
          <div className="lg:w-1/2">
            <p className="text-xs font-semibold text-accent-600 uppercase tracking-wider mb-3">
              Porównanie
            </p>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight">
              Dlaczego użytkownicy wybierają usfansspreadsheet?
            </h2>
          </div>
          <div className="lg:w-1/2 flex items-end">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              Porównaj kluczowe funkcje usfansspreadsheet z tradycyjnymi narzędziami, takimi jak Excel i Google Sheets. Zobacz, dlaczego coraz więcej osób przechodzi na nowoczesne rozwiązania.
            </p>
          </div>
        </div>

        {/* Comparison Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* usfansspreadsheet Card - Wider */}
          <div className="bg-accent-50 rounded-2xl p-6 md:p-8 border border-accent-200/60 md:col-span-1 hover:translate-y-[-2px] transition-transform">
            <div className="w-full h-48 rounded-xl overflow-hidden mb-6">
              <img
                src="https://readdy.ai/api/search-image?query=Futuristic%20holographic%20spreadsheet%20interface%20floating%20above%20transparent%20glass%20desk%2C%20modern%20tech%20office%20with%20ambient%20LED%20lighting%2C%20clean%20minimalist%20design%2C%20warm%20amber%20and%20white%20tones%2C%20professional%203D%20render%20style&width=800&height=600&seq=compare-usfans-v2-01&orientation=squarish"
                alt="usfansspreadsheet - nowoczesny interfejs"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
            <h3 className="font-heading text-xl font-semibold text-foreground-950 mb-2">usfansspreadsheet</h3>
            <p className="text-sm text-foreground-600 mb-4">Nowoczesne narzędzie do zarządzania danymi</p>
            <div className="space-y-2.5">
              {features.map((f) => (
                <div key={f.name} className="flex items-center gap-2.5">
                  <div className={`w-5 h-5 flex items-center justify-center rounded-full ${f.usfans ? 'bg-accent-500 text-background-50' : 'bg-background-200 text-foreground-400'}`}>
                    <i className={`${f.usfans ? 'ri-check-line' : 'ri-close-line'} text-xs`}></i>
                  </div>
                  <span className="text-sm text-foreground-700">{f.name}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Excel Card */}
          <div className="bg-background-100 rounded-2xl p-6 md:p-8 border border-background-200/60 hover:translate-y-[-2px] transition-transform">
            <h3 className="font-heading text-xl font-semibold text-foreground-950 mb-2 text-center">Excel</h3>
            <p className="text-sm text-foreground-600 mb-6 text-center">Klasyczny arkusz kalkulacyjny</p>
            <div className="w-full h-48 rounded-xl overflow-hidden mb-6">
              <img
                src="https://readdy.ai/api/search-image?query=Corporate%20office%20cubicle%20with%20desktop%20computer%20showing%20complex%20grid%20spreadsheet%2C%20stack%20of%20papers%2C%20coffee%20mug%2C%20fluorescent%20office%20lighting%2C%20traditional%20business%20environment%2C%20professional%20office%20photography&width=800&height=600&seq=compare-excel-v2-02&orientation=squarish"
                alt="Microsoft Excel - klasyczny arkusz"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
            <div className="space-y-2.5">
              {features.map((f) => (
                <div key={f.name} className="flex items-center gap-2.5">
                  <div className={`w-5 h-5 flex items-center justify-center rounded-full ${f.excel ? 'bg-accent-500 text-background-50' : 'bg-background-200 text-foreground-400'}`}>
                    <i className={`${f.excel ? 'ri-check-line' : 'ri-close-line'} text-xs`}></i>
                  </div>
                  <span className="text-sm text-foreground-700">{f.name}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Google Sheets Card */}
          <div className="bg-background-100 rounded-2xl p-6 md:p-8 border border-background-200/60 hover:translate-y-[-2px] transition-transform">
            <h3 className="font-heading text-xl font-semibold text-foreground-950 mb-2 text-center">Google Sheets</h3>
            <p className="text-sm text-foreground-600 mb-6 text-center">Arkusz w chmurze</p>
            <div className="w-full h-48 rounded-xl overflow-hidden mb-6">
              <img
                src="https://readdy.ai/api/search-image?query=Bright%20colorful%20tablet%20displaying%20collaborative%20online%20document%20with%20multiple%20cursors%2C%20modern%20coworking%20space%20with%20exposed%20brick%2C%20cheerful%20atmosphere%2C%20daylight%20streaming%20in%2C%20team%20collaboration%20photography&width=800&height=600&seq=compare-sheets-v2-03&orientation=squarish"
                alt="Google Sheets - arkusz w chmurze"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
            <div className="space-y-2.5">
              {features.map((f) => (
                <div key={f.name} className="flex items-center gap-2.5">
                  <div className={`w-5 h-5 flex items-center justify-center rounded-full ${f.sheets ? 'bg-accent-500 text-background-50' : 'bg-background-200 text-foreground-400'}`}>
                    <i className={`${f.sheets ? 'ri-check-line' : 'ri-close-line'} text-xs`}></i>
                  </div>
                  <span className="text-sm text-foreground-700">{f.name}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}